import 'assets/styles/keenpages/login-1.css';
import ActivateAccountScreen from 'features/Account/screens/ActivateAccountScreen';
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

function AccountBaseScreen() {
    const [searchParams] = useSearchParams();
    const action = searchParams.get('action');

    const renderAccountPage = useMemo(() => {
        switch (action) {
            case 'activate':
                return <ActivateAccountScreen />;
            default:
                return <KTPageError01 />;
        }
    }, [action]);

    return <div>{renderAccountPage}</div>;
}

export default AccountBaseScreen;